import {
    SET_CATEGORIES_BENEFITS,
    SET_CATEGORY_TYPE,
    SET_SUBCATEGORIES,
    SET_CATEGORIES_ID,
    SET_CATEGORIES,
    SET_MODO,
} from "@/views/categories_board/store/types/types.js";

const mutations = {
    [SET_CATEGORIES_BENEFITS]: (state, payload) => state.categories_board_benefits = payload,
    [SET_SUBCATEGORIES]: (state, payload) => state.subcategories_board = payload, 
    [SET_CATEGORY_TYPE]: (state, payload) => state.categories_type = payload, 
    [SET_CATEGORIES]: (state, payload) => state.categories_board = payload,  
    [SET_CATEGORIES_ID]: (state, payload) => state.category = payload, 
    [SET_MODO]: (state, payload) => state.modos = payload,
    
};

export default mutations